import * as React from 'react';
import { Modal, Button, Label, Dropdown } from 'semantic-ui-react';

class State {
    homePage: any;
}

interface Props {
    showModal: boolean;
    handleModalClose: any;
    options: any;
    changeHomepage: any;
}

export default class UserSettingsWindow extends React.Component<Props, State> {

    componentWillMount() {
        let homePage;

        if (window.localStorage && (homePage = window.localStorage.getItem('homePage'))) {
            this.setState({
                homePage: homePage
            });
        } else {
            this.setState({
                homePage: ''
            });
        }

    }
    render() {

        const inlineStyle = {
            modal : {
                marginTop: '50px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };

        return (
            <Modal
                open={this.props.showModal}
                onClose={this.props.handleModalClose}
                size="mini"
                style={inlineStyle.modal}
            >
                <Modal.Header>User Settings</Modal.Header>
                <Modal.Content>
                    <Label className="filterPanelLabel">
                        Home Page:
                    </Label>
                    <Dropdown

                        value={this.state.homePage}
                        search
                        selection
                        options={this.props.options}
                        onChange={(event, data) => this.setState({homePage: data.value})}
                    />
                </Modal.Content>
                <Modal.Actions>
                    <Button className="filterPanel-primary-btn modal-button-padding" onClick={() => this.props.changeHomepage(this.state.homePage)}>
                        Change
                    </Button>
                    <Button className="filterPanel-secondary-btn modal-button-padding" onClick={this.props.handleModalClose}>
                        Cancel
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/userSettings.tsx